interface DefaultFeatureProps {}

const DefaultFeature = ({}: DefaultFeatureProps) => {
  return (
    <div className="text-[#8E899F] mt-40 text-center whitespace-pre-wrap">
      회원 관리를 위한 준비가 완료되었습니다.{'\n'}
      피벗과 함께 고객만족도와 재등록률을 올려보세요!
    </div>
  );
};

export default DefaultFeature;
